import { render, staticRenderFns } from "./churuBf.vue?vue&type=template&id=179c9be7&scoped=true"
import script from "./churuBf.vue?vue&type=script&lang=js"
export * from "./churuBf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179c9be7",
  null
  
)

export default component.exports